import type { ProductionCompletionCheck } from "../models";
import type { machineCountLabel } from "../live-counter";
import { amount, operatorNumber } from "./quantity-format";

export function completionCheckRows(check: ProductionCompletionCheck, unit: string, machineUnit: ReturnType<typeof machineCountLabel>) {
  const usesCompletedCases = check.completedCases != null;
  const varianceQuantity = usesCompletedCases ? check.completedCasesVariance : check.varianceQuantity;
  const variance = varianceQuantity == null
    ? "Plan miktarı yok"
    : varianceQuantity === 0
      ? "Tam mutabakat"
      : `${amount(Math.abs(varianceQuantity), unit)} ${varianceQuantity < 0 ? "eksik" : "fazla"}`;
  const rows = [
    ["Planlanan", check.plannedQuantity == null ? "—" : amount(check.plannedQuantity, unit)],
    ...(usesCompletedCases
      ? [["Tamamlanan koli", check.completedCases?.quality === "GOOD" && check.completedCases.runValue != null ? `${operatorNumber(check.completedCases.runValue, 0)} koli` : "İş sayımı doğrulanamadı"]]
      : [
          ...(check.machineCountedBoxes != null ? [["Makinede sayılan", `${operatorNumber(check.machineCountedBoxes)} ${machineUnit}`]] : []),
          ["Sağlam üretim", amount(check.productionQuantity, unit)],
          ["Toplam kayıt", amount(check.totalRecordedQuantity, unit)],
        ]),
    ["Iskarta / kayıp", amount(check.scrapQuantity, unit)],
    ["Miktar farkı", variance],
    ["Açık duruş", check.hasOpenDowntime ? "Var · kapatılmalı" : "Yok"],
    ["Eksik duruş nedeni", check.hasDowntimeWithoutReason ? "Var · seçilmeli" : "Yok"],
    ["Plan notu", check.hasUnacknowledgedPlanNote ? "Onay bekliyor" : "Onaylı / yok"],
    ["Kalite kontrolü", "Kalite durumu doğrulanmadı"],
  ];
  return rows;
}
